import React, { ReactNode } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="h-full fixed top-0 left-0 w-full bg-[#0b0b0b80] bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleOverlayClick}
    >
      {children}
    </div>
  );
};

export default Modal;
